import React, { Component } from 'react';
import Link from 'gatsby-link';

const PostItem = ({ post }) => {
    let el = document.createElement('div');
    el.innerHTML = post.node.content;
    let postImgs = [].slice.call(el.getElementsByTagName('img'));

    return (
        <Link to={`/${post.node.slug}`} className="postLink">
            <div className="postExcerpt">
                <h3
                    dangerouslySetInnerHTML={{
                        __html: post.node.title
                    }}
                />
                <div
                    dangerouslySetInnerHTML={{
                        __html: post.node.excerpt
                    }}
                />
                <div className="postExcerptImage">
                    {postImgs.map(img => <img key={img.src} src={img.src} />)}
                </div>
            </div>
        </Link>
    );
};

class PostContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: props.posts.slice(0, 5)
        };
    }

    render() {
        if (typeof document === 'undefined') {
            return false;
        }

        return (
            <div className="PostContainer">
                <div className="posts">
                    {this.state.posts.map(post => (
                        <PostItem key={post.node.id} post={post} />
                    ))}
                </div>
                <div className="loadMore">
                    <button
                        onClick={() =>
                            this.setState({
                                posts: this.props.posts.slice(
                                    0,
                                    this.state.posts.length + 5
                                )
                            })
                        }>
                        Load more
                    </button>
                </div>
            </div>
        );
    }
}

export default PostContainer;



// WEBPACK FOOTER //
// ./src/components/PostContainer.js